function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 26.5C0 11.864 11.864 0 26.5 0S53 11.864 53 26.5 41.136 53 26.5 53 0 41.136 0 26.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#464a55",
  d: "M30.404 20.857c0 2.297-1.915 4.212-4.212 4.212-2.374 0-4.288-1.915-4.288-4.212a4.281 4.281 0 0 1 4.288-4.288c2.297 0 4.212 1.914 4.212 4.288zm-4.212-6.586a6.537 6.537 0 0 0-6.586 6.586 6.532 6.532 0 0 0 3.063 5.514c-4.748 1.378-8.347 5.513-8.96 10.568-.153 1.378 2.145 1.455 2.298.23.613-5.131 4.901-9.037 10.185-9.037 5.208 0 9.496 3.906 10.109 9.036.153 1.226 2.45 1.15 2.297-.23-.536-5.054-4.135-9.189-8.883-10.567 1.761-1.149 2.986-3.217 2.986-5.514 0-3.676-2.91-6.586-6.509-6.586z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#464a55",
  strokeMiterlimit: 20,
  strokeWidth: 0.5,
  d: "M30.404 20.857c0 2.297-1.915 4.212-4.212 4.212-2.374 0-4.288-1.915-4.288-4.212a4.281 4.281 0 0 1 4.288-4.288c2.297 0 4.212 1.914 4.212 4.288zm-4.212-6.586a6.537 6.537 0 0 0-6.586 6.586 6.532 6.532 0 0 0 3.063 5.514c-4.748 1.378-8.347 5.513-8.96 10.568-.153 1.378 2.145 1.455 2.298.23.613-5.131 4.901-9.037 10.185-9.037 5.208 0 9.496 3.906 10.109 9.036.153 1.226 2.45 1.15 2.297-.23-.536-5.054-4.135-9.189-8.883-10.567 1.761-1.149 2.986-3.217 2.986-5.514 0-3.676-2.91-6.586-6.509-6.586z"
})));

var SvgModalIcon = function SvgModalIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgModalIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ModalIcon.ad0c6fc7.svg";
export { ForwardRef as ReactComponent };